import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { inventoryService, StockMovementCreate, MovementFilters } from '@/services/inventory';

export function useInventorySummary(expiringDays: number = 60) {
  return useQuery({
    queryKey: ['inventory-summary', expiringDays],
    queryFn: () => inventoryService.getSummary(expiringDays),
  });
}

export function useStockAlerts(expiringDays: number = 60) {
  return useQuery({
    queryKey: ['stock-alerts', expiringDays],
    queryFn: () => inventoryService.getAlerts(expiringDays),
  });
}

export function useStockMovements(filters?: MovementFilters) {
  return useQuery({
    queryKey: ['stock-movements', filters],
    queryFn: () => inventoryService.getMovements(filters),
  });
}

export function useCreateStockMovement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: StockMovementCreate) => inventoryService.createMovement(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['stock-movements'] });
      queryClient.invalidateQueries({ queryKey: ['inventory-summary'] });
      queryClient.invalidateQueries({ queryKey: ['stock-alerts'] });
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['product', variables.product_id] });
    },
  });
}
